
// ============================================================================
// DECOMPOSITION MAP - PART 6
// Snacks, Pasta types, Bread types, Canned goods, Frozen items, Alcohol
// ============================================================================

import { DecompositionEntry } from './db-types';

export const snacksAndMore: DecompositionEntry[] = [
  
  // ==========================================================================
  // SNACKS
  // ==========================================================================
  { foodId: "chips", ingredients: ["potato", "vegetable_oil", "salt"] },
  { foodId: "tortilla_chips", ingredients: ["corn_meal", "vegetable_oil", "salt"] },
  { foodId: "popcorn", ingredients: ["corn", "butter", "salt"] },
  { foodId: "nachos", ingredients: ["corn_meal", "cheddar", "tomato", "onion", "jalapeno", "sour_cream", "vegetable_oil", "salt"] },
  { foodId: "pretzels", ingredients: ["flour", "yeast", "butter", "sugar", "salt", "baking_soda"] },
  { foodId: "crackers", ingredients: ["flour", "butter", "salt"] },
  { foodId: "rice_crackers", ingredients: ["rice", "soy_sauce", "sesame", "salt"] },
  { foodId: "breadsticks", ingredients: ["flour", "olive_oil", "yeast", "salt"] },
  { foodId: "bruschetta", ingredients: ["bread", "tomato", "garlic", "basil", "olive_oil", "salt"] },
  { foodId: "crostini", ingredients: ["bread", "olive_oil", "garlic", "salt"] },
  { foodId: "deviled_eggs", ingredients: ["egg", "mayonnaise", "mustard", "paprika", "salt"] },
  { foodId: "spring_roll", ingredients: ["rice_paper", "shrimp", "pork", "carrot", "lettuce", "mint", "cilantro", "fish_sauce", "salt"] },
  { foodId: "samosa", ingredients: ["flour", "potato", "pea", "onion", "garam_masala", "cumin", "coriander_seed", "cilantro", "vegetable_oil", "salt"] },
  { foodId: "pakora", ingredients: ["chickpea", "onion", "bell_pepper", "spinach", "cumin", "turmeric", "vegetable_oil", "salt"] },
  { foodId: "bhaji", ingredients: ["onion", "chickpea", "cumin", "turmeric", "chili_pepper", "cilantro", "vegetable_oil", "salt"] },
  { foodId: "empanada", ingredients: ["flour", "beef", "onion", "egg", "olive", "cumin", "paprika", "chili_pepper", "vegetable_oil", "salt"] },
  { foodId: "croquette", ingredients: ["potato", "ham", "flour", "butter", "milk", "egg", "breadcrumbs", "vegetable_oil", "nutmeg", "salt"] },
  { foodId: "arancini", ingredients: ["rice", "mozzarella", "egg", "breadcrumbs", "tomato", "pea", "parmesan", "vegetable_oil", "salt"] },
  { foodId: "suppli", ingredients: ["rice", "mozzarella", "tomato", "egg", "breadcrumbs", "parmesan", "vegetable_oil", "salt"] },
  { foodId: "falafel", ingredients: ["chickpea", "fava_bean", "onion", "garlic", "cilantro", "parsley", "cumin", "coriander_seed", "vegetable_oil", "salt"] },
  { foodId: "hummus", ingredients: ["chickpea", "tahini", "olive_oil", "lemon", "garlic", "cumin", "salt"] },
  { foodId: "baba_ganoush", ingredients: ["eggplant", "tahini", "olive_oil", "lemon", "garlic", "salt"] },
  { foodId: "edamame", ingredients: ["soybean", "salt"] },
  { foodId: "gyoza", ingredients: ["flour", "pork", "cabbage", "scallion", "garlic", "ginger", "soy_sauce", "sesame_oil", "vegetable_oil", "salt"] },
  { foodId: "dumpling", ingredients: ["flour", "pork", "cabbage", "scallion", "ginger", "soy_sauce", "sesame_oil", "salt"] },
  { foodId: "wonton", ingredients: ["flour", "pork", "shrimp", "scallion", "ginger", "soy_sauce", "sesame_oil", "salt"] },
  { foodId: "tempura", ingredients: ["shrimp", "zucchini", "bell_pepper", "flour", "egg", "vegetable_oil", "salt"] },
  { foodId: "onion_rings", ingredients: ["onion", "flour", "egg", "breadcrumbs", "vegetable_oil", "salt"] },
  { foodId: "mozzarella_sticks", ingredients: ["mozzarella", "flour", "egg", "breadcrumbs", "vegetable_oil", "salt"] },
  { foodId: "jalapeno_poppers", ingredients: ["jalapeno", "cream_cheese", "cheddar", "bacon", "breadcrumbs", "vegetable_oil", "salt"] },
  { foodId: "buffalo_wings", ingredients: ["chicken", "flour", "butter", "tabasco", "vinegar", "celery", "sour_cream", "vegetable_oil", "salt"] },
  { foodId: "chicken_wings", ingredients: ["chicken", "flour", "vegetable_oil", "salt", "black_pepper"] },
  { foodId: "chicken_nuggets", ingredients: ["chicken", "flour", "egg", "breadcrumbs", "vegetable_oil", "salt"] },
  { foodId: "chicken_tenders", ingredients: ["chicken", "flour", "egg", "breadcrumbs", "vegetable_oil", "salt"] },
  { foodId: "fish_sticks", ingredients: ["cod", "flour", "egg", "breadcrumbs", "vegetable_oil", "salt"] },
  { foodId: "calamari", ingredients: ["squid", "flour", "egg", "vegetable_oil", "lemon", "salt"] },
  { foodId: "shrimp_cocktail", ingredients: ["shrimp", "ketchup", "horseradish", "lemon", "worcestershire", "tabasco", "salt"] },
  { foodId: "ceviche", ingredients: ["sea_bass", "cod", "shrimp", "lime", "onion", "tomato", "cilantro", "chili_pepper", "avocado", "salt"] },
  { foodId: "carpaccio", ingredients: ["beef", "olive_oil", "lemon", "parmesan", "arugula", "caper", "salt", "black_pepper"] },
  { foodId: "tartare", ingredients: ["beef", "egg_yolk", "onion", "caper", "pickle", "mustard", "worcestershire", "olive_oil", "salt", "black_pepper"] },
  { foodId: "pate", ingredients: ["liver", "pork", "butter", "onion", "cognac", "thyme", "bay_leaf", "nutmeg", "salt", "black_pepper"] },
  { foodId: "terrine", ingredients: ["pork", "liver", "bacon", "onion", "cognac", "thyme", "bay_leaf", "nutmeg", "egg", "salt"] },
  { foodId: "rillettes", ingredients: ["pork", "duck_fat", "thyme", "bay_leaf", "nutmeg", "salt", "black_pepper"] },
  
  // ==========================================================================
  // PASTA TYPES (simple, just the pasta itself)
  // ==========================================================================
  { foodId: "spaghetti", ingredients: ["flour", "egg", "salt"] },
  { foodId: "penne", ingredients: ["flour", "egg", "salt"] },
  { foodId: "rigatoni", ingredients: ["flour", "egg", "salt"] },
  { foodId: "fusilli", ingredients: ["flour", "egg", "salt"] },
  { foodId: "farfalle", ingredients: ["flour", "egg", "salt"] },
  { foodId: "tagliatelle", ingredients: ["flour", "egg", "salt"] },
  { foodId: "fettuccine", ingredients: ["flour", "egg", "salt"] },
  { foodId: "linguine", ingredients: ["flour", "egg", "salt"] },
  { foodId: "pappardelle", ingredients: ["flour", "egg", "salt"] },
  { foodId: "orecchiette", ingredients: ["flour", "egg", "salt"] },
  { foodId: "gnocchi", ingredients: ["potato", "flour", "egg", "salt"] },
  { foodId: "ravioli", ingredients: ["flour", "egg", "ricotta", "spinach", "parmesan", "salt"] },
  { foodId: "tortellini", ingredients: ["flour", "egg", "pork", "prosciutto", "parmesan", "nutmeg", "salt"] },
  { foodId: "lasagna_sheets", ingredients: ["flour", "egg", "salt"] },
  { foodId: "cannelloni", ingredients: ["flour", "egg", "salt"] },
  { foodId: "macaroni", ingredients: ["flour", "egg", "salt"] },
  { foodId: "orzo", ingredients: ["flour", "egg", "salt"] },
  { foodId: "couscous", ingredients: ["semolina", "salt"] },
  { foodId: "ramen_noodles", ingredients: ["flour", "egg", "salt", "baking_soda"] },
  { foodId: "udon_noodles", ingredients: ["flour", "salt"] },
  { foodId: "soba_noodles", ingredients: ["buckwheat", "flour", "salt"] },
  { foodId: "rice_noodles", ingredients: ["rice", "salt"] },
  { foodId: "glass_noodles", ingredients: ["mung_bean", "sweet_potato", "salt"] },
  { foodId: "egg_noodles", ingredients: ["flour", "egg", "salt"] },
  
  // ==========================================================================
  // BREAD TYPES
  // ==========================================================================
  { foodId: "baguette", ingredients: ["flour", "yeast", "salt"] },
  { foodId: "pain_campagne", ingredients: ["flour", "rye", "yeast", "salt"] },
  { foodId: "pain_complet", ingredients: ["flour", "wheat", "yeast", "salt"] },
  { foodId: "pain_seigle", ingredients: ["rye", "flour", "yeast", "salt"] },
  { foodId: "pain_mie", ingredients: ["flour", "butter", "milk", "sugar", "yeast", "salt"] },
  { foodId: "sourdough", ingredients: ["flour", "salt"] },
  { foodId: "ciabatta", ingredients: ["flour", "olive_oil", "yeast", "salt"] },
  { foodId: "focaccia", ingredients: ["flour", "olive_oil", "yeast", "rosemary", "salt"] },
  { foodId: "pita", ingredients: ["flour", "yeast", "olive_oil", "salt"] },
  { foodId: "naan", ingredients: ["flour", "yogurt", "yeast", "egg", "butter", "sugar", "salt"] },
  { foodId: "roti", ingredients: ["flour", "butter", "salt"] },
  { foodId: "paratha", ingredients: ["flour", "butter", "salt"] },
  { foodId: "chapati", ingredients: ["flour", "salt"] },
  { foodId: "tortilla", ingredients: ["flour", "lard", "salt"] },
  { foodId: "corn_tortilla", ingredients: ["corn_meal", "salt"] },
  { foodId: "lavash", ingredients: ["flour", "salt"] },
  { foodId: "injera", ingredients: ["teff", "salt"] },
  { foodId: "pumpernickel", ingredients: ["rye", "flour", "molasses", "yeast", "salt"] },
  { foodId: "challah", ingredients: ["flour", "egg", "sugar", "vegetable_oil", "yeast", "salt"] },
  { foodId: "brioche", ingredients: ["flour", "butter", "egg", "yeast", "milk", "sugar", "salt"] },
  { foodId: "english_muffin", ingredients: ["flour", "milk", "butter", "yeast", "sugar", "salt"] },
  { foodId: "bagel", ingredients: ["flour", "yeast", "sugar", "salt", "egg"] },
  { foodId: "pretzel", ingredients: ["flour", "yeast", "butter", "sugar", "salt", "baking_soda"] },
  { foodId: "crouton", ingredients: ["bread", "olive_oil", "garlic", "salt"] },
  { foodId: "breadcrumbs", ingredients: ["bread"] },
  { foodId: "panko", ingredients: ["bread"] },
  
  // ==========================================================================
  // CANNED / PRESERVED
  // ==========================================================================
  { foodId: "canned_tomatoes", ingredients: ["tomato", "salt"] },
  { foodId: "tomato_paste", ingredients: ["tomato", "salt"] },
  { foodId: "tomato_sauce", ingredients: ["tomato", "onion", "garlic", "olive_oil", "basil", "salt"] },
  { foodId: "canned_beans", ingredients: ["white_bean", "black_bean", "kidney_bean", "salt"] },
  { foodId: "canned_chickpeas", ingredients: ["chickpea", "salt"] },
  { foodId: "canned_lentils", ingredients: ["lentil", "salt"] },
  { foodId: "canned_corn", ingredients: ["corn", "sugar", "salt"] },
  { foodId: "canned_peas", ingredients: ["pea", "sugar", "salt"] },
  { foodId: "canned_tuna", ingredients: ["tuna", "olive_oil", "salt"] },
  { foodId: "canned_salmon", ingredients: ["salmon", "salt"] },
  { foodId: "canned_sardines", ingredients: ["sardine", "olive_oil", "salt"] },
  { foodId: "canned_anchovies", ingredients: ["anchovy", "olive_oil", "salt"] },
  { foodId: "canned_crab", ingredients: ["crab", "salt"] },
  { foodId: "coconut_cream", ingredients: ["coconut"] },
  { foodId: "coconut_milk", ingredients: ["coconut"] },
  { foodId: "evaporated_milk", ingredients: ["milk"] },
  { foodId: "condensed_milk", ingredients: ["milk", "sugar"] },
  { foodId: "pickles", ingredients: ["cucumber", "vinegar", "dill", "garlic", "salt"] },
  { foodId: "sauerkraut", ingredients: ["cabbage", "salt"] },
  { foodId: "kimchi", ingredients: ["cabbage", "chili_pepper", "garlic", "ginger", "fish_sauce", "salt"] },
  { foodId: "olives", ingredients: ["olive", "salt"] },
  { foodId: "capers", ingredients: ["caper", "salt", "vinegar"] },
  { foodId: "sun_dried_tomatoes", ingredients: ["tomato", "olive_oil", "salt"] },
  { foodId: "roasted_peppers", ingredients: ["bell_pepper", "olive_oil", "garlic", "salt"] },
  { foodId: "artichoke_hearts", ingredients: ["artichoke", "olive_oil", "lemon", "salt"] },
  { foodId: "palm_hearts", ingredients: ["palm", "salt"] },
  { foodId: "bamboo_shoots", ingredients: ["bamboo_shoot", "salt"] },
  { foodId: "water_chestnuts", ingredients: ["water_chestnut"] },
  
  // ==========================================================================
  // FROZEN
  // ==========================================================================
  { foodId: "frozen_pizza", ingredients: ["flour", "tomato", "mozzarella", "ham", "mushroom", "olive_oil", "yeast", "oregano", "salt"] },
  { foodId: "frozen_lasagna", ingredients: ["pasta", "beef", "tomato", "mozzarella", "parmesan", "onion", "garlic", "milk", "butter", "flour", "salt"] },
  { foodId: "frozen_fish_sticks", ingredients: ["cod", "flour", "breadcrumbs", "vegetable_oil", "salt"] },
  { foodId: "frozen_chicken_nuggets", ingredients: ["chicken", "flour", "breadcrumbs", "vegetable_oil", "salt"] },
  { foodId: "frozen_fries", ingredients: ["potato", "vegetable_oil", "salt"] },
  { foodId: "frozen_vegetables", ingredients: ["pea", "carrot", "corn", "green_bean", "salt"] },
  { foodId: "frozen_berries", ingredients: ["strawberry", "blueberry", "raspberry"] },
  { foodId: "frozen_mango", ingredients: ["mango"] },
  { foodId: "ice_cream", ingredients: ["cream", "milk", "egg", "sugar", "vanilla"] },
  { foodId: "sorbet", ingredients: ["fruit", "sugar"] },
  { foodId: "frozen_yogurt", ingredients: ["yogurt", "sugar"] },
  { foodId: "gelato", ingredients: ["milk", "cream", "egg", "sugar"] },
  
  // ==========================================================================
  // ALCOHOL (for cooking)
  // ==========================================================================
  { foodId: "red_wine", ingredients: ["grape"] },
  { foodId: "white_wine", ingredients: ["grape"] },
  { foodId: "rose_wine", ingredients: ["grape"] },
  { foodId: "champagne", ingredients: ["grape"] },
  { foodId: "prosecco", ingredients: ["grape"] },
  { foodId: "sherry", ingredients: ["grape"] },
  { foodId: "port", ingredients: ["grape"] },
  { foodId: "marsala", ingredients: ["grape"] },
  { foodId: "madeira", ingredients: ["grape"] },
  { foodId: "vermouth", ingredients: ["grape", "herb"] },
  { foodId: "beer", ingredients: ["barley", "hop", "yeast"] },
  { foodId: "lager", ingredients: ["barley", "hop", "yeast"] },
  { foodId: "ale", ingredients: ["barley", "hop", "yeast"] },
  { foodId: "stout", ingredients: ["barley", "hop", "yeast"] },
  { foodId: "cider", ingredients: ["apple"] },
  { foodId: "sake", ingredients: ["rice"] },
  { foodId: "mirin", ingredients: ["rice", "sugar"] },
  { foodId: "rice_wine", ingredients: ["rice"] },
  { foodId: "vodka", ingredients: ["potato", "grain"] },
  { foodId: "gin", ingredients: ["grain", "juniper"] },
  { foodId: "rum", ingredients: ["sugar"] },
  { foodId: "whiskey", ingredients: ["barley", "corn", "rye"] },
  { foodId: "bourbon", ingredients: ["corn"] },
  { foodId: "scotch", ingredients: ["barley"] },
  { foodId: "brandy", ingredients: ["grape"] },
  { foodId: "cognac", ingredients: ["grape"] },
  { foodId: "armagnac", ingredients: ["grape"] },
  { foodId: "calvados", ingredients: ["apple"] },
  { foodId: "grappa", ingredients: ["grape"] },
  { foodId: "tequila", ingredients: ["agave"] },
  { foodId: "mezcal", ingredients: ["agave"] },
  { foodId: "pisco", ingredients: ["grape"] },
  { foodId: "kirsch", ingredients: ["cherry"] },
  { foodId: "grand_marnier", ingredients: ["cognac", "orange"] },
  { foodId: "cointreau", ingredients: ["orange"] },
  { foodId: "amaretto", ingredients: ["almond"] },
  { foodId: "kahlua", ingredients: ["coffee", "sugar"] },
  { foodId: "baileys", ingredients: ["cream", "whiskey", "cocoa"] },
  { foodId: "limoncello", ingredients: ["lemon", "sugar"] },
];
